import React from "react";

import {useSelector, useDispatch} from "react-redux";
// import {addReferenceAction} from "../features/sliceReducer/myProjectReducer";
import {makeStyles, createStyles, Theme} from "@material-ui/core/styles";
import SpeedDial from "@material-ui/lab/SpeedDial";
import SpeedDialIcon from "@material-ui/lab/SpeedDialIcon";
import SpeedDialAction from "@material-ui/lab/SpeedDialAction";
import EditIcon from "@material-ui/icons/Edit";
import BuildIcon from "@material-ui/icons/Build";
import CachedIcon from "@material-ui/icons/Cached";
import LibraryBooksIcon from "@material-ui/icons/LibraryBooks";
import HelpIcon from "@material-ui/icons/Help";
import VisibilityIcon from "@material-ui/icons/Visibility";
import SaveIcon from "@material-ui/icons/Save";
import ThumbUpIcon from "@material-ui/icons/ThumbUp";
import AssignmentIcon from "@material-ui/icons/Assignment";
import OpenInBrowserIcon from "@material-ui/icons/OpenInBrowser";
import ScoreIcon from "@material-ui/icons/Score";
import CreateIcon from "@material-ui/icons/Create";
import SaveAltIcon from "@material-ui/icons/SaveAlt";
import {
  evaluationToggleAction,
  helpToggleAction,
  projectModalOpenAction,
  toastPopupOpenAction,
} from "../features/sliceReducer/interactionReducer";
import {
  GuideToggleAction,
  setServerSavedAction,
  updateContainer,
} from "../features/sliceReducer/myProjectReducer";
import {ReferenceProjectAction} from "../features/sliceReducer/projectReducer";
import IPUtility from "../classes/IPUtility";
import {RootState} from "../features/store";
import {useNavigate} from "react-router-dom";
import moment from "moment";
import {logOutAction} from "../features/sliceReducer/authReducer";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      // transform: "translateZ(0px)",
      flexGrow: 1,
    },
    speedDial: {
      position: "fixed",
      bottom: theme.spacing(4),
      left: theme.spacing(4),
    },
    speedDialAction: {
      color: theme.palette.info.main,
    },
  })
);
interface actionInterface {
  icon: JSX.Element;
  name: string;
  clickHandler: () => void;
}
export default function SpeedDials() {
  const {userToken} = useSelector((state: RootState) => state.auth);
  const {isSaving} = useSelector((state: RootState) => state.myProject);
  const {myProject, selectContainer} = useSelector((state: RootState) => state.myProject);
  const actions = [] as actionInterface[];
  actions.push({
    icon: <OpenInBrowserIcon />,
    name: "프로젝트 불러오기",
    clickHandler: () => {
      dispatch(projectModalOpenAction());
      dispatch(ReferenceProjectAction());
    },
  });
  actions.push({
    icon: <VisibilityIcon />,
    name: "가이드 보이기/숨기기",
    clickHandler: () => dispatch(GuideToggleAction()),
  });
  actions.push({
    icon: <HelpIcon />,
    name: "도움말 보이기/숨기기",
    clickHandler: () => dispatch(helpToggleAction()),
  });
  if (!myProject.isNoPoint) {
    actions.push({
      icon: <ScoreIcon />,
      name: "평가점수 보이기/숨기기",
      clickHandler: () => dispatch(evaluationToggleAction()),
    });
  }
  actions.push({
    icon: <AssignmentIcon />,
    name: "시정조치 다운로드",
    clickHandler: () => IPUtility.downloadSheet(myProject.uid, userToken, myProject.name),
  });
  actions.push({
    icon: <CreateIcon />,
    name: "맞춤법 검사기",
    clickHandler: () => {
      window.open("http://speller.cs.pusan.ac.kr/", "_blank");
    },
  });
  actions.push({
    icon: <SaveAltIcon />,
    name: "Word 저장",
    clickHandler: () => {
      dispatch(setServerSavedAction(2));
      IPUtility.saveProjectToLocal(myProject, false);
      dispatch(
        updateContainer({
          userToken: userToken,
          item: IPUtility.dietContainer(IPUtility.getContainerByUID(myProject, selectContainer)),
          points: myProject.manualPointsList,
          projectUID: myProject.uid,
          noContentItemUIDs: myProject.noContentItemUIDs,
          successHandler: () => {
            IPUtility.saveProjectToLocal(myProject, true);
            dispatch(setServerSavedAction(1));
            IPUtility.openWord(
              myProject.uid,
              userToken,
              myProject.factoryName +
                " " +
                moment(myProject.startDate).format("YYYY년 ") +
                myProject.name
            );
          },
          authFailHandler: () => {
            IPUtility.saveProjectToLocal(myProject, false);
            dispatch(setServerSavedAction(0));
            dispatch(
              toastPopupOpenAction({
                contents: "로그아웃 됐습니다. 다시 로그인해주세요",
                severity: "error",
              })
            );
            dispatch(logOutAction());
            navigate("/login");
          },
          failHandler: () => {
            IPUtility.saveProjectToLocal(myProject, false);
            dispatch(setServerSavedAction(0));
            dispatch(
              toastPopupOpenAction({
                contents: "저장하지 못했습니다. 잠시 후 다시 해보세요",
                severity: "error",
              })
            );
          },
        })
      );
    },
  });
  actions.push({
    icon: <BuildIcon />,
    name: "강평자료",
    clickHandler: () => {
      const line = "/document/generateReview/" + myProject.uid + "?userToken=" + userToken;
      window.open(line, "_blank");
      // IPUtility.openReview(myProject.uid, userToken, myProject.name);
    },
  });
    actions.push({
    icon: <BuildIcon />,
    name: "편집용",
    clickHandler: () => {
      const line = "/document/generateReview/" + myProject.uid + "?isEditable=true&userToken=" + userToken;
      window.open(line, "_blank");
      // IPUtility.openReview(myProject.uid, userToken, myProject.name);
    },
  });
  actions.push({
    icon: <SaveIcon />,
    name: "Save",
    clickHandler: () => {
      setOpen(false);
      dispatch(setServerSavedAction(2));
      IPUtility.saveProjectToLocal(myProject, false);
      dispatch(
        updateContainer({
          userToken: userToken,
          item: IPUtility.dietContainer(IPUtility.getContainerByUID(myProject, selectContainer)),
          points: myProject.manualPointsList,
          projectUID: myProject.uid,
          noContentItemUIDs: myProject.noContentItemUIDs,
          successHandler: () => {
            IPUtility.saveProjectToLocal(myProject, true);
            dispatch(setServerSavedAction(1));
            dispatch(
              toastPopupOpenAction({
                contents: "저장되었습니다.",
                severity: "info",
              })
            );
          },
          authFailHandler: () => {
            IPUtility.saveProjectToLocal(myProject, true);
            dispatch(setServerSavedAction(0));
            dispatch(
              toastPopupOpenAction({
                contents: "로그아웃 됐습니다. 다시 로그인해주세요",
                severity: "error",
              })
            );
            dispatch(logOutAction());
            navigate("/login");
          },
          failHandler: () => {
            IPUtility.saveProjectToLocal(myProject, true);
            dispatch(setServerSavedAction(0));
            dispatch(
              toastPopupOpenAction({
                contents: "저장하지 못했습니다. 잠시 후 다시 해보세요",
                severity: "error",
              })
            );
          },
        })
      );
    },
  });

  // const actionsX = [
  //   {
  //     icon: <CachedIcon />,
  //     name: "프로젝트 불러오기",
  //     clickHandler: () => {
  //       dispatch(projectModalOpenAction());
  //       dispatch(ReferenceProjectAction());
  //     },
  //   },
  //   {
  //     icon: <LibraryBooksIcon />,
  //     name: "가이드 보이기/숨기기",
  //     clickHandler: () => dispatch(GuideToggleAction()),
  //   },
  //   {
  //     icon: <HelpIcon />,
  //     name: "도움말 보이기/숨기기",
  //     clickHandler: () => dispatch(helpToggleAction()),
  //   },
  //   {
  //     icon: <ThumbUpIcon />,
  //     name: "평가점수 보이기/숨기기",
  //     clickHandler: () => dispatch(evaluationToggleAction()),
  //   },
  //   {
  //     icon: <VisibilityIcon />,
  //     name: "미리보기",
  //     clickHandler: () => {
  //       dispatch(
  //         updateContainer({
  //           userToken: userToken,
  //           item: IPUtility.dietContainer(
  //             IPUtility.getContainerByUID(myProject, selectContainer)
  //           ),
  //           points: myProject.manualPointsList,
  //           projectUID: myProject.uid,
  //           noContentItemUIDs: myProject.noContentItemUIDs,
  //           successHandler: () =>
  //             IPUtility.openWord(myProject.uid, userToken, myProject.name),
  //         })
  //       );
  //     },
  //   },
  //   {
  //     icon: <SaveIcon />,
  //     name: "저장",
  //     clickHandler: () => {
  //       dispatch(
  //         updateContainer({
  //           userToken: userToken,
  //           item: IPUtility.dietContainer(
  //             IPUtility.getContainerByUID(myProject, selectContainer)
  //           ),
  //           points: myProject.manualPointsList,
  //           projectUID: myProject.uid,
  //           noContentItemUIDs: myProject.noContentItemUIDs,
  //           successHandler: () =>
  //             dispatch(
  //               toastPopupOpenAction({
  //                 contents: "저장되었습니다.",
  //                 severity: "info",
  //               })
  //             ),
  //         })
  //       );
  //     },
  //   },
  //   // {icon: <HomeIcon />, name: "프로젝트 홈", clickHandler: null},
  // ];

  // const openWord = (id: number, userToken: string, fileName: string) => {
  //   const url = `/document/generateDocument/`;
  //   fetch(url, {
  //     headers: {
  //       'Accept': 'application/json',
  //       'Content-Type': 'application/json'
  //     },
  //     method: "POST",
  //     body: JSON.stringify({ id, userToken })
  //   })
  //     .then((response) => response.blob())
  //     .then((blob) => {
  //       // Create blob link to download
  //       const url = window.URL.createObjectURL(
  //         new Blob([blob]),
  //       );
  //       const link = document.createElement('a');
  //       link.href = url;
  //       link.setAttribute(
  //         'download',
  //         `${fileName}.docx`,
  //       );

  //       // Append to html link element page
  //       document.body.appendChild(link);

  //       // Start download
  //       link.click();

  //       // Clean up and remove the link
  //       link?.parentNode?.removeChild(link);
  //     });
  // }

  const dispatch = useDispatch();
  const classes = useStyles();
  const navigate = useNavigate();
  const [open, setOpen] = React.useState<boolean>(false);
  const [hidden, setHidden] = React.useState<boolean>(false);

  const handleVisibility = () => {
    setHidden((prevHidden) => !prevHidden);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div className={classes.root}>
      <SpeedDial
        ariaLabel="SpeedDial openIcon"
        className={classes.speedDial}
        hidden={hidden}
        icon={<SpeedDialIcon openIcon={<EditIcon />} />}
        direction={"right"}
        onClose={handleClose}
        onOpen={handleOpen}
        open={open}
      >
        {actions.map((action) => (
          <SpeedDialAction
            className={classes.speedDialAction}
            key={action.name}
            icon={action.icon}
            tooltipTitle={action.name}
            tooltipPlacement={"top"}
            onClick={action.clickHandler}
          />
        ))}
      </SpeedDial>
    </div>
  );
}
// AddProjectModal
